/*
 * MDB shim for MDBNav
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx - done
 * - src/Seating/PurchaseQueue/purchaseQueueView.jsx - done
 * - src/Seating/Tasks/Tasks.jsx - done
 */
import MUIAppBar from "@mui/material/AppBar";
import MUITabs from "@mui/material/Tabs";
import { Children } from "react";

export default function MDBNav({ children, ...rest }) {
  const tabCount = Children.toArray(children).filter(Boolean).length;
  return (
    <MUIAppBar
      position="static"
      sx={{
        backgroundColor: "#5881C1",
        boxShadow:
          "0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)",
      }}
    >
      <MUITabs
        value={false}
        variant="fullWidth"
        sx={{
          width: "100%",
          "& .MuiTabs-flexContainer": {
            display: "grid",
            gridTemplateColumns: `repeat(${Math.max(tabCount, 1)}, minmax(0, 1fr))`,
            width: "100%",
          },
          "& .MuiTab-root": {
            color: "#ffffff",
            opacity: 1,
            textTransform: "none",
            fontSize: "1rem",
            minHeight: "48px",
            maxWidth: "none",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.1)",
            },
          },
        }}
        {...rest}
        slotProps={{
          indicator: { style: { display: "none" } },
        }}
      >
        {children}
      </MUITabs>
    </MUIAppBar>
  );
}
